// export const APIBASE = 'http://localhost'
// export const APIBASE = 'https://smart-restaurant.duckdns.org'
export const APIBASE = 'https://smart-restaurant.ie.nthu.edu.tw'

export const NAME = 'CONSTANT.Name'

export const ASPECTS = [
  { key: 'food', title: 'ASPECT.Food' },
  { key: 'service', title: 'ASPECT.Service' },
  { key: 'atmosphere', title: 'ASPECT.Atmosphere' },
  { key: 'cleanliness', title: 'ASPECT.Cleanliness' },
  { key: 'value', title: 'ASPECT.Value' }
]

export const QUICK_DIRECT = [
  { key: 'nearby', text: 'QUICKDIRECT.Nearby', searchText: 'QUICKDIRECT.NearbyText' },
  { key: 'food',text: 'QUICKDIRECT.Food', searchText: 'QUICKDIRECT.FoodText' },
  { key: 'value',text: 'QUICKDIRECT.Value', searchText: 'QUICKDIRECT.ValueText' },
  { key: 'atmosphere',text: 'QUICKDIRECT.Atmosphere', searchText: 'QUICKDIRECT.AtmosphereText' },
  { key: 'service',text: 'QUICKDIRECT.Service', searchText: 'QUICKDIRECT.ServiceText' }
]

export const LOCALES = {
  'tw': {
    lang: 'tw',
    api: 'tw',
    defaultLat: 24.79612,
    defaultLng: 120.993,
    adjustLng: 0.008755
  },
  'us_nyc': {
    lang: 'en',
    api: 'us_nyc',
    defaultLat: 40.8297,
    defaultLng: -73.874,
    adjustLng: 0
  }
}

export const GOOGLE_MAP_APIKEY = 'AIzaSyDgpOYNOdSJl8y4KL1Qoy7x_g8dg9bKJug'
export const GOOGLE_MAP_MAPID = '1d5d8fc4fee7baf8'
